import { Injectable } from '@nestjs/common';
import { InjectDataSource } from '@nestjs/typeorm';
import { BarcodeTypeEnum, GlobalResponseObject, OperationCategoryEnum, PoStatusEnum } from '@shahi-analytics/shared-models';
import { DataSource, Not, Repository } from 'typeorm';
import { BuyerEntity } from '../entities/buyer.entity';
import { DcEntity } from '../entities/dc.entity';
import { MigrationLogEntity } from '../entities/migration-log.entity';
import { OperationEntity } from '../entities/operation.entity';
import { PoHeaderEntity } from '../entities/po-header.entity';
import { PoLineEntity } from '../entities/po-line.entity';
import { ScheduleEntity } from '../entities/schedule.entity';
import { StyleOperationEntity } from '../entities/style-op.entity';
import { TrackingInfoEntity } from '../entities/tracking-info.entity';
import { DbNamesEnum } from './db-connection/db-names.enum';
import { GtsDbConnectionsService } from './db-connection/shahi-db-connection';
import { GenericTransactionManager } from '../../database/typeorm-transactions';
import { UnitEntity } from '../entities/unit.entity';
import { LineEntity } from '../entities/line.entity';
import { GtsAppTableNamesEnum } from '../gts/models/app-table-names.enum';
import { TableMigrationStatusEnum } from '../gts/models/table-migration-status.enum';



@Injectable()
export class GtsMigrationHelperService {
  private opEnt: Repository<OperationEntity>;
  private poHeaderEnt: Repository<PoHeaderEntity>;
  private poLineEnt: Repository<PoLineEntity>;
  private schEnt: Repository<ScheduleEntity>;
  private trackInfoEnt: Repository<TrackingInfoEntity>;
  private styleOpEnt: Repository<StyleOperationEntity>;
  private dcEnt: Repository<DcEntity>
  private migLogEnt: Repository<MigrationLogEntity>
  private unitEnt: Repository<UnitEntity>

  constructor(
    private dataSource: DataSource,
    private transManager: GenericTransactionManager,
    private gtsDb: GtsDbConnectionsService
  ) { 
    this.opEnt = dataSource.getRepository(OperationEntity);
    this.poHeaderEnt = dataSource.getRepository(PoHeaderEntity);
    this.poLineEnt = dataSource.getRepository(PoLineEntity);
    this.schEnt = dataSource.getRepository(ScheduleEntity);
    this.trackInfoEnt = dataSource.getRepository(TrackingInfoEntity);
    this.styleOpEnt = dataSource.getRepository(StyleOperationEntity);
    this.migLogEnt = dataSource.getRepository(MigrationLogEntity);
    this.dcEnt = dataSource.getRepository(DcEntity);
    this.unitEnt = dataSource.getRepository(UnitEntity);
  }
  

  async getActiveUnits(): Promise<UnitEntity[]> {
    return await this.unitEnt.find({ where: { isActive: true }});
  }

  async getUnitRecord(unitId: string): Promise<UnitEntity> {
    return await this.unitEnt.findOne({ where: { unitId: unitId }});
  }

  async checkIfDataDumpedForADateAndHour(date: string, hour: number, unit: string): Promise<boolean> {
    const records = await this.trackInfoEnt.findOne({ select: ['id'], where: { date: date, hour: hour, unitId: unit, refType: BarcodeTypeEnum.BUN } });
    return records ? true : false;
  }

  async checkIfMigrationIsDoneForTableDateAndHour(date: string, hour: number, unit: string, tableName: GtsAppTableNamesEnum): Promise<boolean> {
    const records = await this.migLogEnt.findOne({select:['id'], where: { unitId: unit, migrationDate: date, hour: hour, tableName: tableName, status: Not(TableMigrationStatusEnum.FAILED)}});
    return records ? true : false; 
  }


}


